// components/ModalPopup.jsx
import React, { useState, useEffect } from "react";
import "./ModalPopup.css";
import { useNavigate } from "react-router-dom";

const ModalPopup = () => {
  const [showPopup, setShowPopup] = useState(true);
  const [imageUrl, setImageUrl] = useState("");
  const navigate = useNavigate();

  const SHEET_CSV_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vSrDKrKlJXv2DY5JZpKXRvCf2dYOoFW3EBmblecr9Rw_V2SedlCOrO1eveOSLjcgAi9JAHbtAsCbogu/pub?output=csv"; // Replace with your CSV sheet URL

  useEffect(() => {
    fetch(SHEET_CSV_URL)
      .then(res => res.text())
      .then(csvText => {
        const rows = csvText.split("\n");
        const data = rows[1]?.split(","); // Assuming image URL is in second row, first column
        if (data?.length > 0) {
          setImageUrl(data[0]);
        }
      })
      .catch(err => console.error("Failed to fetch image from sheet", err));
  }, []);

  if (!showPopup) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <button className="popup-close" onClick={() => setShowPopup(false)}>
          X
        </button>
        <div>
        {imageUrl && (
          <img src={imageUrl} alt="Special Offer" className="popup-image" />
        )}
        </div>
        <button
          className="popup-cta"
          onClick={() => {
            setShowPopup(false);
            navigate("/CustomPackage");
          }}
        >
          Make Your Package Now
        </button>
      </div>
    </div>
  );
};

export default ModalPopup;
